import { Component } from '@angular/core';
import { AdminListCartComponent } from "../../../../components/admin-dashboard-component/admin-cart-component/admin-list-cart-component/admin-list-cart-component";

@Component({
  selector: 'app-admin-cart-list',
  imports: [AdminListCartComponent],
  templateUrl: './admin-cart-list.html',
  styleUrl: './admin-cart-list.scss'
})
export class AdminCartList {

}
